/** Schaltflächenleiste der Kopfzeile — `<div class="buttons" style="float:right">`. */

import type { CSSProperties, ReactNode } from 'react';

export interface ViewToolbarProps {
  children: ReactNode;
}

/** Der Altclient setzt `float:right` zusätzlich als Inline-Regel. */
const STYLE: CSSProperties = { float: 'right' };

export function ViewToolbar(props: ViewToolbarProps) {
  // `iwm-view-actions` ist der Name des Entwurfs für dieselbe Leiste (REQ-21 §3); `buttons`
  // bleibt daneben stehen, weil die Regeln aus `_view-header.scss` daran hängen.
  return (
    <div className="buttons iwm-view-actions" style={STYLE}>
      {props.children}
    </div>
  );
}

export default ViewToolbar;
